import { UserData } from '../../../constants';

const DreamHome1 = {
  label: 'Get your Dream Home',
  sections: [
    {
      type: 'text',
      text: (user: UserData) => {
        return `
        <br />
        <h5 style="margin-bottom:10px;">${
          user.firstName ? `${user.firstName}, ` : ''
        } let us help you buy your dream home</h5>
        <p class="light">Start planning for long term goals right now.</p>
        <img class="full-width" src="https://assets1.cleartax-cdn.com/clearsave/images/children-future.png" />
        <br /><br />
        <p class="light">Mutual funds give you better returns for the same monthly investment over the long term.</p>
        `;
      },
    },
  ],
};

export default DreamHome1;



// WEBPACK FOOTER //
// ./components/recommendation/cards/dreamHome1.ts